import { DwAPIList } from '@/api'

const api = new DwAPIList();

export default {

  getCustomerReport({ state }, params, parseTypeEnum = api.api.ParseTypeEnum.json) {
    return new Promise((resolve, reject) => {
      api.getCustomerReport(params, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      }, parseTypeEnum)
    })
  },

  exportCustomerReport({ state }, params, parseTypeEnum = api.api.ParseTypeEnum.empty) {
    return new Promise((resolve, reject) => {
      api.getCustomerReport(params, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      }, parseTypeEnum, {
        responseType: 'arraybuffer'
      })
    })
  },

  getPerformanceReport({ state }, params, parseTypeEnum = api.api.ParseTypeEnum.json) {
    return new Promise((resolve, reject) => {
      api.getPerformanceReport(params, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      }, parseTypeEnum)
    })
  },

  exportPerformanceReport({ state }, params, parseTypeEnum = api.api.ParseTypeEnum.empty) {
    return new Promise((resolve, reject) => {
      api.getPerformanceReport(params, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      }, parseTypeEnum, {
        responseType: 'arraybuffer'
      })
    })
  },

  // getSaleReport({ state, commit, dispatch }, params, parseTypeEnum = api.api.ParseTypeEnum.json) {
  //   return new Promise((resolve, reject) => {
  //     api.getSaleReport(params, (json) => {
  //       resolve(json);
  //     }, (err) => {
  //       reject(err);
  //     }, parseTypeEnum)
  //   })

  // },

  getSaleReport({ state, commit, dispatch }, params) {

    var saleReport = new Promise((resolve, reject) => {
      api.getSaleReport(params, (json) => {
        resolve({ name: 'saleReport', value: json });
      }, (err) => {
        reject(err);
      })
    })

    var getOptions = new Promise((resolve, reject) => {

      dispatch('getAllSelections', 'dw', { root: true })
        .then((json) => {
          console.debug(json);
          commit({ type: 'setSelections', selections: json.data });
          resolve({ name: 'allselections', value: json.data });
        });
    })

    return Promise.all([saleReport, getOptions])
      .then((values) => {
        return new Promise((resolve, reject) => {
          var rs = values.find((element) => {
            return element.name === 'saleReport'
          });
          // console.debug(rs);
          // console.debug(rs.value);

          commit({ type: 'setSelectedPolicyType', policyType: params.policyType });
          resolve(rs.value);
        })
      });
  },

  exportSaleReport({ state, commit, dispatch }, params, parseTypeEnum = api.api.ParseTypeEnum.empty) {
    return new Promise((resolve, reject) => {
      api.getSaleReport(params, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      }, parseTypeEnum, {
        responseType: 'arraybuffer'
      })
    })
  },

  // getRenewalReport({ state }, params) {
  //   return new Promise((resolve, reject) => {
  //     api.getRenewalReport(params, (json) => {
  //       resolve(json);
  //     }, (err) => {
  //       reject(err);
  //     })
  //   })
  // },

  getCommissionReport({ state }, params) {
    return new Promise((resolve, reject) => {
      api.getCommissionReport(params, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      })
    })
  },

  getFormList({ state }, params) {
    return new Promise((resolve, reject) => {
      api.getFormList(params, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      })
    })
  },
  createForm({ state, commit }, param) {
    return new Promise((resolve, reject) => {
      api.createForm(param, (json) => {

        resolve(json.data);
      }, (err) => {
        reject(err);
      });
    });
  },

  getFormDetail({ state }, detailID) {
    return new Promise((resolve, reject) => {
      let param = [];
      param.push({ key: 'ID', value: detailID });
      api.getFormDetail(param, (json) => {
        resolve(json.data);
      }, (err) => {
        reject(err);
      });
    });
  },
  editForm({ state, commit }, param) {
    return new Promise((resolve, reject) => {
      api.editForm(param, (json) => {
        resolve(json.data);
      }, (err) => {
        reject(err);
      });
    });
  },
  deleteForm({ state, commit }, params) {
    return new Promise((resolve, reject) => {
      api.deleteForm(params, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      })
    })
  },

  getAgentCommissionReport({ state }, params, parseTypeEnum = api.api.ParseTypeEnum.json) {
    return new Promise((resolve, reject) => {
      api.getAgentCommissionReport(params, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      }, parseTypeEnum)
    })
  },


  exportAgentCommissionReport({ state }, params, parseTypeEnum = api.api.ParseTypeEnum.empty) {
    return new Promise((resolve, reject) => {
      api.getAgentCommissionReport(params, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      }, parseTypeEnum, {
        responseType: 'arraybuffer'
      })
    })
  },

  getCompanyCommissionReport({ state }, params, parseTypeEnum = api.api.ParseTypeEnum.json) {
    return new Promise((resolve, reject) => {
      api.getCompanyCommissionReport(params, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      }, parseTypeEnum)
    })
  },


  exportCompanyCommissionReport({ state }, params, parseTypeEnum = api.api.ParseTypeEnum.empty) {
    return new Promise((resolve, reject) => {
      api.getCompanyCommissionReport(params, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      }, parseTypeEnum, {
        responseType: 'arraybuffer'
      })
    })
  },

  getRenewalReport({ state }, params, parseTypeEnum = api.api.ParseTypeEnum.json) {
    if (!('orderBy' in params) && !('direction' in params)) {
      params = {
        ...params,
        orderBy: 'updateTime',
        direction: 'desc'
      }
    }
    return new Promise((resolve, reject) => {
      api.getRenewalReport(params, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      }, parseTypeEnum)
    })
  },

  exportRenewalReport({ state }, params, parseTypeEnum = api.api.ParseTypeEnum.empty) {
    return new Promise((resolve, reject) => {
      api.getRenewalReport(params, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      }, parseTypeEnum, {
        responseType: 'arraybuffer'
      })
    })
  },

  getGiPolicyReport({ state }, params, parseTypeEnum = api.api.ParseTypeEnum.json) {
    return new Promise((resolve, reject) => {
      api.getGiPolicyReport(params, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      }, parseTypeEnum)
    })
  },

  exportGiPolicyReport({ state }, params, parseTypeEnum = api.api.ParseTypeEnum.empty) {
    return new Promise((resolve, reject) => {
      api.getGiPolicyReport(params, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      }, parseTypeEnum, {
        responseType: 'arraybuffer'
      })
    })
  },

  getLifePolicyReport({ state }, params, parseTypeEnum = api.api.ParseTypeEnum.json) {
    return new Promise((resolve, reject) => {
      api.getLifePolicyReport(params, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      }, parseTypeEnum)
    })
  },

  exportLifePolicyReport({ state }, params, parseTypeEnum = api.api.ParseTypeEnum.empty) {
    return new Promise((resolve, reject) => {
      api.getLifePolicyReport(params, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      }, parseTypeEnum, {
        responseType: 'arraybuffer'
      })
    })
  },

  getClaimReport({ state }, params, parseTypeEnum = api.api.ParseTypeEnum.json) {
    return new Promise((resolve, reject) => {
      api.getClaimReport(params, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      }, parseTypeEnum)
    })
  },

  exportClaimReport({ state }, params, parseTypeEnum = api.api.ParseTypeEnum.empty) {
    return new Promise((resolve, reject) => {
      api.getClaimReport(params, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      }, parseTypeEnum, {
        responseType: 'arraybuffer'
      })
    })
  },

  getSrReport({ state }, params, parseTypeEnum = api.api.ParseTypeEnum.json) {
    return new Promise((resolve, reject) => {
      api.getSrReport(params, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      }, parseTypeEnum)
    })
  },

  exportSrReport({ state }, params, parseTypeEnum = api.api.ParseTypeEnum.empty) {
    return new Promise((resolve, reject) => {
      api.getSrReport(params, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      }, parseTypeEnum, {
        responseType: 'arraybuffer'
      })
    })
  },
}



// WEBPACK FOOTER //
// ./src/Dw/store/actions.js